var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useCallback, useMemo, } from 'react';
import styled from '@emotion/styled';
import { size } from 'polished';
import { border, borderColor, borderRight, color, display, flex, position, space, themeGet, fontSize, lineHeight, textAlign, width, maxWidth, height, alignItems, } from 'styled-system';
import { borderRadiusBL, borderRadiusBR, borderRadiusTL, borderRadiusTR, fill, stroke, themeRight, themeTop, } from '../../theme/system-utilities';
import Icon from '../../components/Icon';
import Input from '../Input';
import { Button } from '../Button';
export var FormStateType;
(function (FormStateType) {
    FormStateType[FormStateType["Default"] = 0] = "Default";
    FormStateType[FormStateType["Success"] = 1] = "Success";
    FormStateType[FormStateType["Warning"] = 2] = "Warning";
    FormStateType[FormStateType["Error"] = 3] = "Error";
})(FormStateType || (FormStateType = {}));
var ICON_SIZE = 20;
var SubmitInputForm = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, width);
SubmitInputForm.defaultProps = {
    display: 'flex',
    width: 1,
};
var FieldIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), size(ICON_SIZE), position, themeTop, themeRight, stroke, fill);
FieldIcon.defaultProps = {
    position: 'absolute',
    themeRight: 'sp_8',
    themeTop: '10px',
};
var SubmitInputLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), flex, position, display);
SubmitInputLabel.defaultProps = {
    position: 'relative',
    display: 'flex',
    flex: 1,
};
var SubmitInputInput = styled(Input)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n\n  &:active,\n  &:focus {\n    border-color: ", ";\n  }\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n  &::placeholder {\n    color: ", ";\n  }\n  &::-ms-clear {\n    display: none;\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n\n  &:active,\n  &:focus {\n    border-color: ",
    ";\n  }\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n  &::placeholder {\n    color: ", ";\n  }\n  &::-ms-clear {\n    display: none;\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n"])), border, borderRight, borderColor, color, space, borderRadiusTR, borderRadiusBR, function (_a) {
    var isHome24 = _a.theme.isHome24;
    return !isHome24 && 'border-radius: 0;';
}, function (_a) {
    var hasIcon = _a.hasIcon;
    return hasIcon && 'padding-right: 32px;';
}, function (_a) {
    var activeColor = _a.activeColor, props = __rest(_a, ["activeColor"]);
    return themeGet("colors." + activeColor)(props);
}, themeGet('colors.gray.4'), themeGet('colors.gray.15'), themeGet('colors.gray.15'));
SubmitInputInput.defaultProps = __assign(__assign({}, Input.defaultProps), { px: 'sp_12', borderRight: 'none', border: '1px solid', color: 'gray.9', mb: 0, borderRadiusTR: 0, borderRadiusBR: 0 });
var SubmitInputButton = styled(Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:disabled {\n    border-color: ", ";\n  }\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:disabled {\n    border-color: ", ";\n  }\n  ",
    "\n"])), borderColor, borderRadiusTL, borderRadiusBL, height, display, alignItems, themeGet('colors.gray.5'), function (_a) {
    var kind = _a.kind, props = __rest(_a, ["kind"]);
    return kind === 'secondary' &&
        "\n    > svg[role=presentation] {\n      stroke: " + themeGet('colors.gray.7')(props) + ";\n    }\n  ";
});
SubmitInputButton.defaultProps = {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    borderRadiusTL: 0,
    borderRadiusBL: 0,
    px: 'sp_8',
};
var SubmitInputMessage = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"])), space, display, fontSize, lineHeight, textAlign, width, maxWidth, color);
SubmitInputMessage.defaultProps = {
    mt: 'sp_4',
    fontSize: 'fs_14',
    lineHeight: 'lh_20',
    textAlign: 'left',
    width: 1,
    maxWidth: [null, null, '511px'],
};
var getPropsForFieldState = function (state) {
    switch (state) {
        case FormStateType.Success:
            return { stateColor: 'green.60', icon: 'success' };
        case FormStateType.Error:
            return { stateColor: 'red.60', icon: 'error' };
        case FormStateType.Warning:
            return { stateColor: 'yellow.70', icon: 'warning' };
        default:
            return { stateColor: 'gray.5' };
    }
};
var submitInputs = 0;
var SubmitInput = function (_a) {
    var inputLabel = _a.inputLabel, inputType = _a.inputType, inputName = _a.inputName, inputDisabled = _a.inputDisabled, inputRequired = _a.inputRequired, onChange = _a.onChange, onSubmit = _a.onSubmit, value = _a.value, state = _a.state, buttonLabel = _a.buttonLabel, buttonContent = _a.buttonContent, buttonKind = _a.buttonKind, buttonBorderColor = _a.buttonBorderColor, buttonDisabled = _a.buttonDisabled, isLoading = _a.isLoading, message = _a.message;
    var _b = getPropsForFieldState(state), stateColor = _b.stateColor, icon = _b.icon;
    var handleSubmit = useCallback(function (event) {
        event.preventDefault();
        if (!isLoading) {
            onSubmit(event);
        }
    }, [isLoading, onSubmit]);
    var idNumber = useMemo(function () { return submitInputs++; }, []);
    return (React.createElement(Fragment, null,
        React.createElement(SubmitInputForm, { onSubmit: handleSubmit, noValidate: true },
            React.createElement(SubmitInputLabel, null,
                React.createElement(SubmitInputInput, { "aria-describedby": "submit-input-message-" + idNumber, "aria-label": inputLabel, type: inputType, name: inputName, value: value, onChange: onChange, placeholder: inputLabel, disabled: inputDisabled, borderColor: stateColor, required: inputRequired, activeColor: FormStateType.Default === state ? 'gray.9' : stateColor, hasIcon: !!icon }),
                icon && (React.createElement(FieldIcon, { name: icon, fill: stateColor, stroke: stateColor }))),
            React.createElement(SubmitInputButton, { type: "submit", disabled: buttonDisabled, isLoading: isLoading, kind: buttonKind, borderColor: buttonBorderColor, "aria-label": buttonLabel }, buttonContent)),
        message && (React.createElement(SubmitInputMessage, { color: stateColor, "data-testid": "message", id: "submit-input-message-" + idNumber, role: "alert" }, message))));
};
SubmitInput.defaultProps = {
    inputType: 'text',
    buttonKind: 'primary',
};
export default SubmitInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
